module.exports = __webpack_public_path__ + "img/logo-white.e6d5e764.svg";